import { FC } from 'react';
import Image, { StaticImageData } from 'next/image';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

import Avatar1 from './assets/avatar1.png';
import Avatar2 from './assets/avatar2.png';
import Avatar3 from './assets/avatar3.png';
import LGFGIcon from './assets/LGFG.svg';
import StarIcon from './assets/Star.svg';
import RangetellerIcon from './assets/Rangeteller.svg';
import GartnerIcon from './assets/Gartner.svg';
import SnowflakeIcon from './assets/Snowflake.svg';

import { Container } from '@/components';

import styles from './styles.module.scss';

const RATING_ITEMS = Array.from({ length: 5 }, (_, index) => index);

const ClientTestimonial: FC<{
  text: string;
  author: {
    avatar: StaticImageData;
    name: string;
    position: string;
  };
}> = ({ text, author }) => {
  return (
    <Box className={styles.testimonial}>
      <Box className={styles.testimonialRating}>
        {RATING_ITEMS.map((item) => (
          <StarIcon key={item} />
        ))}
      </Box>
      <Typography variant="body1" className={styles.testimonialText}>
        {text}
      </Typography>
      <Box className={styles.testimonialAuthor}>
        <Box className={styles.testimonialAuthorAvatar}>
          <Image src={author.avatar} alt={author.name} />
        </Box>
        <Stack>
          <Typography variant="body1" className={styles.testimonialAuthorName}>
            {author.name}
          </Typography>
          <Typography variant="body1" className={styles.testimonialAuthorPosition}>
            {author.position}
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};

export const ClientTestimonials: FC = () => {
  const { t } = useTranslation('pricingV2', { keyPrefix: 'testimonials' });

  return (
    <Box component="section" className={styles.section}>
      <Container>
        <Box className={styles.wrapper}>
          <Typography variant="h2" className={styles.title}>
            {t('title')}
          </Typography>
          <Box className={styles.iconsList}>
            <Box className={styles.iconItem}>
              <RangetellerIcon />
            </Box>
            <Box className={styles.iconItem}>
              <GartnerIcon />
            </Box>
            <Box className={styles.iconItem}>
              <SnowflakeIcon />
            </Box>
            <Box className={styles.iconItem}>
              <LGFGIcon />
            </Box>
          </Box>
          <Box className={styles.testimonials}>
            <ClientTestimonial
              text={t('items.0.text')}
              author={{
                avatar: Avatar1,
                name: t('items.0.author.name'),
                position: t('items.0.author.position'),
              }}
            />
            <ClientTestimonial
              text={t('items.1.text')}
              author={{
                avatar: Avatar2,
                name: t('items.1.author.name'),
                position: t('items.1.author.position'),
              }}
            />
            <ClientTestimonial
              text={t('items.2.text')}
              author={{
                avatar: Avatar3,
                name: t('items.2.author.name'),
                position: t('items.2.author.position'),
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
